// material-ui
import { styled, Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

interface Props {
  theme: Theme;
  open: boolean;
}

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }: Props) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'flex-start' : 'center',
  marginLeft: open ? '30px' : 0,
  marginRight: open ? '30px' : 0,
  paddingTop: open ? '30px' : 0,
  paddingBottom: open ? '30px' : 0,
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexShrink: 0
}));

export default DrawerHeaderStyled;
